import {
  type FlowCareGapAlgorithmBlockConfig,
  FlowCareGapAlgorithmBlockConfigSchema,
  FlowProducedType,
} from 'flow-schema';
import { type CareGapAlgorithm } from 'primary-schema';

import { CareGapFormFields } from './FormFields';
import { careGapDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const careGapAlgorithmNodeConfig: BlockConfigProps<FlowCareGapAlgorithmBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'careGapAlgorithm',
  defaultConfig: {
    algorithm: '' as CareGapAlgorithm,
    payload: {
      documents: {
        sourceBlockName: '',
        consumesType: FlowProducedType.DocumentExtract,
      },
      problems: {
        sourceBlockName: '',
        consumesType: FlowProducedType.Conditions,
      },
      medications: {
        sourceBlockName: '',
        consumesType: FlowProducedType.Medications,
      },
      labValues: {
        sourceBlockName: '',
        consumesType: FlowProducedType.LabValues,
      },
      procedures: {
        sourceBlockName: '',
        consumesType: FlowProducedType.SurgicalHistories,
      },
    },
  },
  configFields: {
    schema: FlowCareGapAlgorithmBlockConfigSchema,
    FormFields: CareGapFormFields,
  },
  documentationMarkdown: careGapDocumentationMarkdown,
};
